// Descarga con el NOMBRE ORIGINAL del fichero (Trabajo B). Utilidad común para AAFF, adjuntos, archivos cliente/DNF.
import { toast } from "sonner";

const INVALIDOS = /[\\/:*?"<>|\u0000-\u001f]/g;

export function nombreDescarga(a) {
  const url = a?.url || "";
  let n = (a?.nombre_original || a?.nombre || a?.filename || "").trim();
  if (!n) n = decodeURIComponent(url.split("?")[0].split("/").pop() || "archivo");
  n = n.replace(INVALIDOS, "_").replace(/^[ .]+|[ .]+$/g, "") || "archivo";
  if (!/\.[A-Za-z0-9]{1,5}$/.test(n)) {
    const extUrl = (url.split("?")[0].split("/").pop() || "").match(/\.([A-Za-z0-9]{1,5})$/);
    if (extUrl) n = `${n}.${extUrl[1]}`;
  }
  return n.slice(0, 200);
}

export function esDescargableProxy(url) {
  try { return /(^|\.)cloudinary\.com$/.test(new URL(url).hostname); } catch { return false; }
}

// Descarga vía blob → el navegador respeta `download` exactamente (espacios, ñ, paréntesis, versión…).
export async function descargarArchivo(a) {
  const nombre = nombreDescarga(a);
  if (!a?.url) return;
  if (a.es_url_externa || !esDescargableProxy(a.url)) {
    window.open(a.url, "_blank", "noopener");
    return;
  }
  try {
    const token = localStorage.getItem("dnf_access_token");
    const qs = new URLSearchParams({ url: a.url, nombre });
    const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/descargas/proxy?${qs}`, { headers: { Authorization: `Bearer ${token}` } });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    const blob = await r.blob();
    const href = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = href; link.download = nombre; link.rel = "noopener";
    document.body.appendChild(link); link.click(); link.remove();
    setTimeout(() => URL.revokeObjectURL(href), 60_000);
  } catch (e) {
    toast.error(`No se pudo descargar «${nombre}»`);
  }
}
